import { useState } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';

export type TypeaheadOption = string | Record<string, Object>;

export default function useEITypeahead() {
    const [singleSelections, setSingleSelections] = useState<TypeaheadOption[]>([]);
    const [multiSelections, setMultiSelections] = useState<TypeaheadOption[]>([]);
    const [options, setOptions] = useState<TypeaheadOption[]>([]);

    const onChangeSingleSelection = (selected: TypeaheadOption[]) => {
        setSingleSelections(selected);
    };

    const onChangeMultipleSelection = (selected: TypeaheadOption[]) => {
        setMultiSelections(selected);
    };

    return {
        options,
        setOptions,
        singleSelections,
        multiSelections,
        onChangeSingleSelection,
        onChangeMultipleSelection,
    };
}
